import { useState } from 'react';

export default function FeaturedProperties() {
  const [activeFilter, setActiveFilter] = useState('all');

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const properties = [
    {
      id: 1,
      type: 'residential',
      title: 'Luxury Villa in Prime Location',
      location: 'Beverly Hills, California',
      price: 'Rs 850,000,000',
      beds: 5,
      baths: 4,
      area: '4,500',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20villa%20exterior%20with%20contemporary%20architecture%2C%20elegant%20white%20facade%20with%20large%20glass%20windows%2C%20manicured%20landscaping%20with%20palm%20trees%20and%20green%20lawn%2C%20upscale%20residential%20property%20in%20premium%20neighborhood%2C%20golden%20hour%20lighting%20creating%20warm%20ambiance%2C%20high-end%20real%20estate%20photography%20showcasing%20architectural%20excellence%20and%20luxury%20lifestyle&width=800&height=600&seq=property-villa-1&orientation=landscape',
      featured: true,
      status: 'For Sale'
    },
    {
      id: 2,
      type: 'commercial',
      title: 'Modern Commercial Complex',
      location: 'Downtown Business District',
      price: 'Rs 1,560,000,000',
      beds: null,
      baths: null,
      area: '12,000',
      image: 'https://readdy.ai/api/search-image?query=Contemporary%20commercial%20office%20building%20with%20sleek%20glass%20facade%2C%20modern%20corporate%20architecture%20featuring%20clean%20lines%20and%20professional%20design%2C%20urban%20business%20district%20setting%20with%20clear%20blue%20sky%2C%20premium%20commercial%20real%20estate%20property%2C%20architectural%20photography%20highlighting%20sophisticated%20business%20environment%20and%20investment%20opportunity&width=800&height=600&seq=property-commercial-1&orientation=landscape',
      featured: true,
      status: 'For Sale'
    },
    {
      id: 3,
      type: 'residential',
      title: 'Contemporary Family Home',
      location: 'Suburban Heights',
      price: 'Rs 435,000,000',
      beds: 4,
      baths: 3,
      area: '3,200',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20contemporary%20family%20home%20with%20modern%20design%2C%20two-story%20residential%20property%20featuring%20elegant%20exterior%20with%20stone%20and%20wood%20accents%2C%20well-maintained%20front%20yard%20with%20professional%20landscaping%2C%20welcoming%20entrance%20with%20large%20windows%2C%20suburban%20neighborhood%20setting%2C%20warm%20natural%20lighting%20showcasing%20comfortable%20family%20living&width=800&height=600&seq=property-family-home-1&orientation=landscape',
      featured: false,
      status: 'For Sale'
    },
    {
      id: 4,
      type: 'land',
      title: 'Prime Development Land',
      location: 'Coastal Development Zone',
      price: 'Rs 1,140,000,000',
      beds: null,
      baths: null,
      area: '25,000',
      image: 'https://readdy.ai/api/search-image?query=Expansive%20vacant%20development%20land%20with%20ocean%20views%2C%20pristine%20undeveloped%20property%20with%20natural%20landscape%2C%20coastal%20location%20perfect%20for%20real%20estate%20development%2C%20clear%20horizon%20and%20blue%20sky%2C%20investment%20opportunity%20land%20parcel%2C%20professional%20real%20estate%20photography%20showing%20development%20potential%20and%20prime%20location%20value&width=800&height=600&seq=property-land-1&orientation=landscape',
      featured: false,
      status: 'Available'
    },
    {
      id: 5,
      type: 'commercial',
      title: 'Retail Shopping Center',
      location: 'Metropolitan Area',
      price: 'Rs 2,550,000,000',
      beds: null,
      baths: null,
      area: '28,000',
      image: 'https://readdy.ai/api/search-image?query=Modern%20retail%20shopping%20center%20with%20contemporary%20design%2C%20multi-tenant%20commercial%20property%20featuring%20attractive%20storefronts%2C%20well-designed%20parking%20area%20with%20professional%20landscaping%2C%20urban%20commercial%20real%20estate%20in%20busy%20metropolitan%20location%2C%20daytime%20photography%20showcasing%20active%20business%20environment%20and%20investment%20potential&width=800&height=600&seq=property-retail-1&orientation=landscape',
      featured: true,
      status: 'For Lease'
    },
    {
      id: 6,
      type: 'residential',
      title: 'Penthouse Apartment',
      location: 'City Center Tower',
      price: 'Rs 960,000,000',
      beds: 3,
      baths: 3,
      area: '2,800',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20penthouse%20apartment%20building%20exterior%2C%20high-rise%20residential%20tower%20with%20modern%20glass%20architecture%2C%20upscale%20urban%20living%20in%20city%20center%20location%2C%20contemporary%20high-end%20condominium%20with%20premium%20amenities%2C%20evening%20photography%20with%20elegant%20lighting%2C%20sophisticated%20metropolitan%20lifestyle%20and%20exclusive%20real%20estate%20opportunity&width=800&height=600&seq=property-penthouse-1&orientation=landscape',
      featured: false,
      status: 'For Sale'
    }
  ];

  const filteredProperties = activeFilter === 'all' 
    ? properties 
    : properties.filter(p => p.type === activeFilter);

  return (
    <section id="properties" className="py-32 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden" data-product-shop>
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 bg-blue-500/10 border border-blue-500/20 px-5 py-2 rounded-full">
            <div className="w-2 h-2 bg-blue-600 rounded-full" />
            <span className="text-blue-700 font-semibold text-sm tracking-wider uppercase">Featured Properties</span>
          </div>
          
          <h3 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Discover Your{' '}
            <span className="bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent">
              Perfect Property
            </span>
          </h3>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10 leading-relaxed">
            Explore our carefully curated selection of premium properties, from luxury residences to prime commercial spaces and development opportunities.
          </p>

          {/* Filter Tabs */}
          <div className="inline-flex gap-2 bg-white p-2 rounded-2xl shadow-lg border border-gray-100">
            <button
              onClick={() => setActiveFilter('all')}
              className={`px-8 py-3 rounded-xl font-bold transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === 'all' 
                  ? 'bg-gradient-to-r from-red-600 to-blue-600 text-white shadow-lg shadow-blue-500/30' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              All Properties
            </button>
            <button
              onClick={() => setActiveFilter('residential')}
              className={`px-8 py-3 rounded-xl font-bold transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === 'residential' 
                  ? 'bg-gradient-to-r from-red-600 to-blue-600 text-white shadow-lg shadow-blue-500/30' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              Residential
            </button>
            <button
              onClick={() => setActiveFilter('commercial')}
              className={`px-8 py-3 rounded-xl font-bold transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === 'commercial' 
                  ? 'bg-gradient-to-r from-red-600 to-blue-600 text-white shadow-lg shadow-blue-500/30' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              Commercial
            </button>
            <button
              onClick={() => setActiveFilter('land')}
              className={`px-8 py-3 rounded-xl font-bold transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === 'land' 
                  ? 'bg-gradient-to-r from-red-600 to-blue-600 text-white shadow-lg shadow-blue-500/30' 
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              Land
            </button>
          </div>
        </div>

        {/* Properties Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-product-shop>
          {filteredProperties.map((property) => (
            <div 
              key={property.id}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-blue-500/30 cursor-pointer"
              data-product-shop
            >
              {/* Image */}
              <div className="relative overflow-hidden h-72">
                <img 
                  src={property.image}
                  alt={property.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {/* Badges */}
                {property.featured && (
                  <div className="absolute top-5 left-5 bg-gradient-to-r from-red-600 to-blue-600 text-white px-4 py-2 rounded-full text-xs font-bold shadow-lg">
                    FEATURED
                  </div>
                )}
                <div className="absolute top-5 right-5 bg-black/80 backdrop-blur-sm text-white px-4 py-2 rounded-full text-xs font-bold">
                  {property.status}
                </div>
              </div>

              {/* Content */}
              <div className="p-7">
                {/* Location */}
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <i className="ri-map-pin-line text-blue-600"></i>
                  <span className="font-medium">{property.location}</span>
                </div>

                {/* Title */}
                <h4 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors leading-tight">
                  {property.title}
                </h4>

                {/* Features */}
                <div className="flex items-center gap-5 mb-5 pb-5 border-b border-gray-200">
                  {property.beds && (
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-hotel-bed-line text-blue-600"></i>
                      <span className="font-semibold">{property.beds}</span>
                    </div>
                  )}
                  {property.baths && (
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-drop-line text-blue-600"></i>
                      <span className="font-semibold">{property.baths}</span>
                    </div>
                  )}
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-ruler-line text-blue-600"></i>
                    <span className="font-semibold">{property.area} sqft</span>
                  </div>
                </div>

                {/* Price & Action */}
                <div className="flex items-center justify-between">
                  <div className="text-3xl font-bold bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent">
                    {property.price}
                  </div>
                  <button 
                    onClick={scrollToContact}
                    className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-600 to-blue-600 rounded-xl hover:shadow-lg hover:shadow-blue-500/50 text-white transition-all group-hover:scale-110 cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-xl"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <button 
          onClick={scrollToContact}
          className="bg-gradient-to-r from-red-600 to-blue-600 text-white px-12 py-5 rounded-xl hover:shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 font-bold text-lg whitespace-nowrap cursor-pointer"
        >
          View All Properties
        </button>
      </div>
    </section>
  );
}
